module.exports = __webpack_public_path__ + "fonts/scaligero_74b54fda981b44e1863203e61a251351.ttf";